import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import axios from "../../../API/axios";
import AppliedJobs from "./AppliedJobs";
import SavedJobs from "./SavedJobs";
import JobOffers from "./JobOffers";
import CallingForInterviews from "./CallingForInterviews";
import { Helmet } from "react-helmet";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import WorkOutlineSharpIcon from "@mui/icons-material/WorkOutlineSharp";
import CardGiftcardSharpIcon from "@mui/icons-material/CardGiftcardSharp";
import BookmarkBorderSharpIcon from "@mui/icons-material/BookmarkBorderSharp";
import EventAvailableSharpIcon from "@mui/icons-material/EventAvailableSharp";
import WorkHistorySharpIcon from "@mui/icons-material/WorkHistorySharp";
import GoogleAdUnit from "../../../components/GoogleAdUnit";
import "./ManageJobs.css";

const MANAGE_JOBS_TAB_MAP = {
  applied: 1,
  offeredjobs: 2,
  savedjobs: 3,
  interviewscheduled: 4,
};

const MANAGE_JOBS_TAB_ROUTES = {
  1: "Applied",
  2: "OfferedJobs",
  3: "SavedJobs",
  4: "InterviewScheduled",
};

const getManageJobsTabIndex = (routeTab) => {
  const tabKey = (routeTab || "").toLowerCase();
  return MANAGE_JOBS_TAB_MAP[tabKey] || 1;
};

const History = () => {
  const sessionId = localStorage.getItem("sessionId");
  const { t } = useTranslation();
  const [tabsCount, setTabsCount] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const { tab } = useParams();
  const [activeTab, setActiveTab] = useState(() => getManageJobsTabIndex(tab));

  const goToManageJobsTab = (tabIndex) => {
    const tabPath = MANAGE_JOBS_TAB_ROUTES[tabIndex];
    if (tabPath) {
      window.scrollTo({ top: 0, behavior: "auto" });
      navigate(`/ManageJobs/${tabPath}`, { state: null });
    }
  };

  const getCountofAllTabs = () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
    };
    axios
      .post(`ManageJob/GetManageJobStats`, data)
      .then((response) => {
        const res = response?.data?.responseData;
        setTabsCount(res);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getCountofAllTabs();
  }, [sessionId]);

  const renderTabContent = () => {
    switch (activeTab) {
      case 1:
        return (
          <AppliedJobs tabsCount={tabsCount} setTabsCount={setTabsCount} />
        );
      case 2:
        return <JobOffers />;
      case 3:
        return (
          <SavedJobs tabsCount={tabsCount} setTabsCount={setTabsCount} />
        );
      case 4:
        return <CallingForInterviews />;
      default:
        return null;
    }
  };

  useEffect(() => {
    setActiveTab(getManageJobsTabIndex(tab));
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [tab]);

  useEffect(() => {
    if (location.state?.activeTab) {
      const tabPath = MANAGE_JOBS_TAB_ROUTES[location.state.activeTab];
      if (tabPath) {
        navigate(`/ManageJobs/${tabPath}`, { replace: true, state: null });
      }
    }
  }, [location.state?.activeTab, navigate]);

  const formatTabCount = (count) =>
    count != null ? ` (${count})` : "";

  return (
    <>
      <Helmet>
        <title>Manage Jobs | Welinkjobs </title>
        <meta
          name="description"
          content="Easy manage jobs with Welinkjobs. Experience efficiency on one of the most trusted job search sites."
        />
        <meta
          property="og:title"
          content="Welinkjobs: Effortlessly Manage Jobs Online"
        />
        <meta
          property="og:description"
          content="Easy manage jobs with Welinkjobs. Experience efficiency on one of the most trusted job search sites."
        />
        <meta property="og:url" content="https://welinkjobs.com/ManageJobs" />
      </Helmet>

      <div className="manageJobsPage-ad">
        <Row>
          <Col md={12}>
            <div
              className="Adwrapper"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "150px",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  display: "block",
                  width: "100%",
                  height: "150px",
                }}
              >
                <GoogleAdUnit
                  adSlot="5695666532"
                  layoutKey="-6t+ed+2i-1n-4w"
                  fullWidthResponsive={false}
                  style={{
                    display: "block",
                    width: "100%",
                    height: "150px",
                    textAlign: "center",
                    margin: "0 auto",
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div className="friendsHeaderText manageJobsPage-header wlj-page-header">
        <h1>
          <WorkHistorySharpIcon className="manage-jobs-page-title-icon" />
          {t("Manage Job.Manage Jobs")}
        </h1>
        <p className="discovery-subtitle mb-2">
          {t("Manage Job.ManageJobsSubtitle", {
            defaultValue:
              "Track applications, offers, saved roles, and upcoming interviews.",
          })}
        </p>
      </div>

      <div className="main-container manageJobsPage job-history p-2 wlj-page-shell">
        <div className="tabButton d-flex w-100 ps-0 manageJobsTab allconnectionTab connectionTab wlj-tab-bar">
          <div
            role="button"
            tabIndex={0}
            onClick={() => goToManageJobsTab(1)}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                goToManageJobsTab(1);
              }
            }}
            className={`text-center pointer ${activeTab === 1 ? "activeTab" : ""}`}
          >
            <WorkOutlineSharpIcon className="manage-jobs-tab-icon" />
            <p className="f-14 tabName">
              {t("Manage Job.Applied Jobs")}
              {formatTabCount(tabsCount?.totalJobApplications)}
            </p>
          </div>
          <div
            role="button"
            tabIndex={0}
            onClick={() => goToManageJobsTab(2)}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                goToManageJobsTab(2);
              }
            }}
            className={`text-center pointer ${activeTab === 2 ? "activeTab" : ""}`}
          >
            <CardGiftcardSharpIcon className="manage-jobs-tab-icon" />
            <p className="f-14 tabName">
              {t("Manage Job.Jobs Offered")}
              {formatTabCount(tabsCount?.totalJobOffers)}
            </p>
          </div>
          <div
            role="button"
            tabIndex={0}
            onClick={() => goToManageJobsTab(3)}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                goToManageJobsTab(3);
              }
            }}
            className={`text-center pointer ${activeTab === 3 ? "activeTab" : ""}`}
          >
            <BookmarkBorderSharpIcon className="manage-jobs-tab-icon" />
            <p className="f-14 tabName">
              {t("Manage Job.Saved Jobs")}
              {formatTabCount(tabsCount?.totalSavedJobs)}
            </p>
          </div>
          <div
            role="button"
            tabIndex={0}
            onClick={() => goToManageJobsTab(4)}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                goToManageJobsTab(4);
              }
            }}
            className={`text-center pointer ${activeTab === 4 ? "activeTab" : ""}`}
          >
            <EventAvailableSharpIcon className="manage-jobs-tab-icon" />
            <p className="f-14 tabName">
              {t("Manage Job.Interview Scheduled")}
              {formatTabCount(tabsCount?.totalScheduledInterviews)}
            </p>
          </div>
        </div>

        <div className="manageJobs-section">{renderTabContent()}</div>
      </div>
    </>
  );
};

export default History;
